import React from 'react';
import { SectionPanel } from 'ui';
import { ComplexValue } from 'app/types-shared';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { ExternalUrlSectionType } from '../metroline/types';
import { ExternalUrlSection } from '../types';
import { ExternalUrlItem } from 'app/area/external-urls-administration/form/types-store';
import { LinkExclude } from 'app/area/external-urls-administration/form/link-fields';

interface ExternalUrlVisibilityProps extends ExternalUrlSection {
  originalExternalUrlItem: ExternalUrlItem;
}

export const ExternalUrlVisibility: React.FC<ExternalUrlVisibilityProps> = ({
  externalUrlItem, originalExternalUrlItem, validation, translation, section, options,
  updateExcludedFields, loadOptions, getRef, shouldRenderSection, resetValidation
}) => {

  const isReadOnly = externalUrlItem?.id === 0;

  const onChange = (value: ComplexValue<number>[]) => {
    updateExcludedFields(value);
    resetValidation('exclude');
  };

  return <MetroLineSection<ExternalUrlSectionType>
    section={section}
    sectionType={ExternalUrlSectionType.Visibility}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(ExternalUrlSectionType.Visibility)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={ExternalUrlSectionType.Visibility}
        validation={undefined}
        info={{ text: translation.visibility }}
        label={{ visible: true, text: translation.visibility }} />
      <MainGridContainer>
        <div className="row">
          <LinkExclude
            externalUrlItem={externalUrlItem}
            validation={validation}
            originalExternalUrlItem={originalExternalUrlItem}
            options={options}
            loadOptions={loadOptions}
            onChange={onChange}
            readOnly={isReadOnly}
            translation={translation} />
        </div>
      </MainGridContainer>
    </div>
  </MetroLineSection>;
};
